import ForgotPassword from "./ForgotPassword.vue";

export default {
    "forgot-password": ForgotPassword,
};
